<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :disabled="disabled"
    :close-on-content-click="false"
    :nudge-right="40"
    lazy
    transition="scale-transition"
    menu-props="offsetY"
    full-width
    min-width="290px"
    :return-value.sync="dates"
  >
    <template v-slot:activator="{ on }">
      <v-combobox
        :value="modifiedDates"
        :style="{paddingTop: padding}"
        multiple
        chips
        small-chips
        :label="label"
        readonly
        :rules="rules"
        hide-details
        :outline="outline ? outline : true"
        :height="heightField ? heightField : 44"
        :prepend-inner-icon="hideDataTypeIcon ? '' : 'event'"
        v-on="on"
      />
    </template>
    <v-date-picker
      v-model="dates"
      multiple
      no-title
      locale="ru-ru"
      scrollable
      :readonly="isReadonly"
      :min="min"
      :max="max"
      first-day-of-week="1"
    >
      <v-spacer />
      <v-btn
        flat
        color="primary"
        @click="menu = false"
      >
        Отмена
      </v-btn>
      <v-btn
        flat
        color="primary"
        @click="save"
      >
        OK
      </v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
export default {
  props: [
    "label",
    "value",
    "readonly",
    "min",
    "max",
    "rules",
    "padding",
    "disabled",
    "outline",
    "heightField",
    "hideDataTypeIcon",
  ],
  data() {
    return {
      dates: [],
      menu: false,
    };
  },
  computed: {
    isReadonly() {
      return this.readonly ? this.readonly : false;
    },
    modifiedDates() {
      const dates = this.dates
        .map(date => {
          return this.moment(date.substr(0, 10)).unix();
        })
        .sort((a, b) => {
          return +a - +b;
        });

      return dates.map(date => {
        return this.moment(date * 1000).format("DD-MM-YY");
      });
    },
  },
  watch: {
    value() {
      this.setDate(this.value);
    },
    menu() {
      if (this.menu) {
        this.$emit("opened");
      }
    },
  },
  created() {
    this.setDate(this.value);
  },
  methods: {
    setDate(value) {
      this.dates = value.map(date => {
        return this.moment(date.substr(0, 10)).format("YYYY-MM-DD");
      });
    },
    save() {
      this.$refs["menu"].save(this.dates);
      this.$emit("input", this.dates);
    },
  },
};
</script>
<style>
table .v-menu__activator .v-text-field .v-input__control .v-input__slot:before {
  border-style: none;
}
</style>
